const publicModule = {
  title: "报警类型",
  pageTitle: "Vehicle operation service management platform",
  resMsg: "验证失败，请重新登录",
  cancel: "取消",
  define: "确定",
  close: "关闭",
  startUp: "启动",
  tips: "提示",
  deleteTips: "请选中需要删除项",
  ordinaryDeleteTips: "普通用户只能删除自定义项目",
  administratorsDeleteTips: "管理员只能删除常规维修和其他维修",
  usersDeleteTips: "用户只能删除自建项目",
  deleteItemTips: "是否删除此项?",
  updateTips: "请选中需要编辑项",
  viewTips: "请选中需要查看项",
  createTips: "请选中需要新增的项",
  noSelectTips: "请选中需要绑定的车辆",
  operationTips: "请选中需要操作的项",
  createSuccess: "新增成功",
  updateSuccess: "编辑成功",
  deleteSuccess: "删除成功",
  setSuccess: "设置成功",
  add: "添加",
  delete: "删除",
  update: "编辑",
  create: "新增",
  search: "查询",
  clear: "清空",
  more: "更多",
  open: "展开",
  packUp: "收起",
  note: "备注",
  others: "其他",
  operation: "操作",
  view: "查看",
  revoke: "撤销",
  createTime: "创建时间",
  usertypeList: {
    internalUsers: "内部用户",
    externalUsers: "外部用户"
  },
  startTime: "开始时间",
  endTime: "结束时间",
  quickQuery: "快速查询",
  quickQueryLabelWidth: "65px",
  organizationName: "组织名称",
  licensePlate: "车牌号码",
  licensePlatewidth1: "75px",
  importDialog: {
    title: "导入",
    file: "文件",
    browse: "浏览",
    note: "注:若已上传过的文件需重新选择方可上传",
    downloadTemplate: "下载模板",
    success: "成功",
    uploadSuccess: "文件上传成功",
    selectFile: "请选择上传文件",
    restFile: "该文件已上传请重新选择上传文件"
  },
  reset: "重置",
  import: "导入",
  basicMode: "基础模式",
  default: "蓝色",
  green: "绿色",
  modelName: "车型名称",
  other: {
    yes: "是",
    no: "否",
    off:'否',
    on:'是',
    dataTime: "数据上报时间",
    area: "使用区域",
    voltage: "常电电压",
    isDriving: "是否行驶",
    can: "CAN数据",
    gpsMileage: "GPS里程",
    signalStrength: "信号强度",
    speed: "车速",
    vSpeed: "车速",
    noGroup: "未分组",
    finallyData: "车辆下线前最后一次上报的数据",
    textIndent: "67px"
  },
  timeError: "开始时间不能大于结束时间，请重新选择",
  unbind: "解绑",
  bind: "绑定",
  gender: "性别",
  male: "男",
  female: "女",
  userName: "用户姓名",
  mobile: "手机号码",
  enable: "启用",
  ban: "禁用",
  all: "所有",
  uploadImageFailed: "图片上传失败，请稍后重试！",
  viewDetail: "查看详情",
  defaultpassword: "默认密码：12345678",
  remarkDescription: "最多能输入200个字",
  uploading: "文件上传中",
  obdCode: "OBD设备号",
  lengthMessage: "字符长度不能超过",
  expirationTime: "过期时间",
  driveSmallPlate: "驱动小板",
  upgradeTime: "升级时间",
  maxValue: "最大值",
  minValue: "最小值",
  checkCarSelect: "选择车辆",
  chose: "选择",
  choseObd: "选择OBD设备号",
  setting: "设置",
  terminal: "终端编号",
  firmwareVersion: "固件版本",
  mpuVersion: "MPU 版本",
  changeAlarm: "异动报警",
  wakeUpOnTime: "定时唤醒",
  cancelTaskTips: "是否撤销该任务?",
  cancelAllTaskTips: "是否撤销选择任务?",
  clickCancle: "点击取消",
  fail: "失败",
  success: "成功",
  noResponse: "无响应",
  description: "描述",
  sim: "SIM卡号",
  iccid: "ICCID",
  simWidth: "100px",
  noSetting: "未设置",
  opens: "开启",
  operationStatus: "操作状态",
  operTarget: "操作目标",
  register: "注册",
  forget: "忘记密码",
  changePassword: "修改密码",
  changeMobile: "修改手机号",
  account: "账户",
  vehicle: "车辆",
  fence: "电子围栏",
  newCreate: "创建",
  edit: "编辑",
  cancelTask: "撤销任务",
  noCommad: "请选择命令项",
  normalMode: "正常工作模式",
  busSleep: "总线休眠",
  lockCarOpen: "开启锁车",
  cancelLockCar: "关闭锁车",
  commandVehicle: "命令车辆",
  command: "命令项",
  taskInformation: "任务信息",
  noNormalMode: "请选择休眠模式",
  confirmUrl: "请仔细检查OBD设备连接地址，防止OBD设备失联",
  IPorDomain: "IP或者域名",
  export: "导出",
  obdNote: "备注：仅V2A2开头OBD设备号可选择驱动小板。",
  formLoadFailed: "表单加载失败",
  baseInfo: "基础信息",
  totalmileage:"总里程",
  duration:"持续时间",
  consumptionrate:"消耗率",
  averagespeed:"平均速度",
  totalidletime:"总空闲时间",
  vehicletype:"车型",
  currentvehiclestatus:"当前车辆状态",
  models:"型号",
  latitude:"纬度",
  longitude:"经度",
  maxSpeed:"最大速度",
  startldletime:"开始空闲时间",
  endldletime:"结束空闲时间",
  totalldletime:"总空闲时间",
  Percentpertrip:"每次行程百分比",
  Totalfueluse:"总燃料的使用",
  averageconsumption:"平均消耗量",
  lastlocation:"最后报警位置",
  lasttime:"最后报警时间",
  vibrationlocation:"异动位置",
  vibrationtime:"异动时间",
  ignitionlocation:"点火位置",
  ignitiontime:"点火时间",
  overspeedtime:"超速时间",
  timesofoverspeed:"超速次数",
  geofencename:"电子围栏名",
  status:"状态（驶入/驶出电子围栏）",
  entertime:"驶入时间",
  durationsig:"时距（待在电子围栏中)",
  exittime:"驶出时间",
  durationsog:"时距（待在电子围栏外",
  faultgroup:"故障分组",
  faultcode:"故障码",
  faultdescription:"故障描述",
  diagnosticstartdatatime:"诊断开始日期/时间",
  diagnosticenddatatime:"诊断结束日期/时间",
  carnum:"车辆总数",
  offlinenum:"脱机设备数",
  parkengineon:"驻车发动机开启次数",
  parkengineoff:"驻车发动机关闭次数",
  normalspeeddrive:"正常速度行驶次数",
  overspeeddrive:"超速行驶次数",
  offline:"离线",
  online:"在线",
  maintenance:"车辆保养",
  repair:"车辆维修"
  

} 
export default publicModule